export default function BalloonDefenseIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none" strokeLinecap="round">
      <path d="M0 50c14 0 18-14 32-14s18 14 32 14" stroke="#e3c48f" strokeWidth="10" />
      <path d="M22 26v10M42 20v12" stroke="#555" strokeWidth="1.5" />
      <ellipse cx="22" cy="17" rx="8" ry="10" fill="#ff3b3b" />
      <ellipse cx="19" cy="13" rx="2.5" ry="3.5" fill="#fff" opacity=".5" />
      <ellipse cx="42" cy="11" rx="7" ry="9" fill="#2f8bff" />
      <ellipse cx="39.5" cy="7.5" rx="2" ry="3" fill="#fff" opacity=".5" />
      <path d="M54 14l-6 6M54 26l-6-4" stroke="#fff" strokeWidth="2.5" />
      <path d="M4 50l-3-6M5 46l-2-7M8 44l0-7M12 43l2-7M16 44l4-6" stroke="#5a3a22" strokeWidth="1.8" />
      <circle cx="12" cy="52" r="9" fill="#ff8a3d" />
      <circle cx="9" cy="50" r="2" fill="#fff" />
      <circle cx="15" cy="50" r="2" fill="#fff" />
      <path d="M18 50l12-14" stroke="#8a5a34" strokeWidth="2" />
      <path d="M30 36l-4 1 2 2z" fill="#3a2416" />
    </svg>
  );
}
